// extracted by mini-css-extract-plugin
module.exports = {"container":"serp_container__aUF0K","research-title":"serp_research-title__Ez2u4"};